module.exports = __webpack_public_path__ + "img/5.4be4a1b6.png";